import script from "./ColorsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorsPanel.vue?vue&type=script&setup=true&lang=js"

import "./ColorsPanel.vue?vue&type=style&index=0&id=743e863d&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743e863d"]])

export default __exports__